<script setup lang="ts">
import type { NuxtError } from '#app'
import Error404 from '#common/components/Error/Error404.vue'
import Error500 from '#common/components/Error/Error500.vue'

const props = defineProps({
  error: {
    type: Object as () => NuxtError,
    default: () => ({
      statusCode: 500,
      message: '',
      url: '',
    }),
  },
})

const errorPage = computed(() => {
  if (props.error.statusCode === 404) {
    return Error404
  } // catch everything else
  return Error500
})
onMounted(async () => {
  console.log(props.error)
})
</script>

<template>
  <div class="nuxt-error">
    <component :is="errorPage" :error="error" />
  </div>
</template>
